/**
 * Swiper
 */

// 最小限の機能しか入っていない
// import Swiper from 'swiper';
// 全ての機能が入っている
// import Swiper from 'swiper/bundle';
// コアバージョンに加えて、ナビゲーションとページネーションを追加する
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard } from 'swiper/modules';

// swiper module list
// A11y, Autoplay, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom

// MV
export function mvSwiper() {
  window.addEventListener('load', () => {

    const elem = document.querySelector('.js-mv-slider');
    if (elem === null) return;

    const mvSwiper = new Swiper('.js-mv-slider', {
      modules: [Autoplay, Pagination, EffectFade],
      loop: true,
      speed: 1000,
      effect: 'slide',
      // fadeEffect: {
      //   crossFade: true
      // },
      autoplay: false,
      autoplay: {
      //   delay: 8000, // 切り替わるまでの時間
        // disableOnInteraction: false,
        waitForTransition: true,
      },
      roundLengths: true,
      // allowTouchMove: false, // マウスでのスワイプを禁止

      pagination: {
        el: '.slide-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      navigation: {
        nextEl: '.slide-button-next',
        prevEl: '.slide-button-prev',
      },

    });

  });

}


// モーダル内スライダー サイズの選び方
export function cardSwiper() {

  window.addEventListener('load', () => {

    const cardSwiper = new Swiper('.p-quick-modal-size .swiper', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 'auto',
      // autoHeight: true,
      spaceBetween: 16,
      grabCursor: true,
      watchSlidesProgress: true,
      pagination: {
        el: '.p-quick-modal-size .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.p-quick-modal-size .swiper-button-next',
        prevEl: '.p-quick-modal-size .swiper-button-prev',
      },
      breakpoints: {
        1025: {
          spaceBetween: 20,
        }
      },
    });

  });

}

// グループページ内 サイズの選び方
export function cardSwiperSize() {

  window.addEventListener('load', () => {

    const cardSwiper = new Swiper('.c-choose-size .swiper', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 'auto',
      // slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchSlidesProgress: true,
      // speed: 1500,
      navigation: {
        nextEl: '.c-choose-size .swiper-button-next',
        prevEl: '.c-choose-size .swiper-button-prev',
      },
      breakpoints: {
        1025: {
          spaceBetween: 20,
        }
      },
    });

  });

}

export function slideSwiper() {
  window.addEventListener('load', () => {

    const allSwipers = document.querySelectorAll('.js-swiper-slider');

    allSwipers.forEach(function(swiperContainer) {
      const swiper = new Swiper(swiperContainer, {

        modules: [Autoplay, Pagination, EffectFade, Keyboard],
        loop: false,
        speed: 1000,
        effect: 'slide',
        roundLengths: true,
        navigation: {
          nextEl: swiperContainer.querySelector('.slide-button-next'),
          prevEl: swiperContainer.querySelector('.slide-button-prev'),
        },
        keyboard: {
          enabled: false, // 初期状態ではキーボード操作を無効に
          onlyInViewport: true
        }

      });

      // マウスがスライダーの上にある時にキーボード操作を有効にする
      swiperContainer.addEventListener('mouseenter', () => {
        swiper.keyboard.enable();
      });

      // マウスがスライダーから離れた時にキーボード操作を無効にする
      swiperContainer.addEventListener('mouseleave', () => {
        swiper.keyboard.disable();
      });

    });

  });
}

// 今すぐ購入
export function slideSwiperQuick() {
  window.addEventListener('load', () => {

    const allSwipers = document.querySelectorAll('.js-quick-slider');

    allSwipers.forEach(function(swiperContainer) {

      if (swiperContainer.swiper) {
        return; // このswiperContainerはすでに初期化されているので、スキップ
      }
      const imageUrls = Array.from(swiperContainer.querySelectorAll('.swiper-slide img')).map(img => img.src);

      const swiper = new Swiper(swiperContainer, {

        modules: [Autoplay, Pagination, EffectFade, Keyboard],
        loop: false,
        speed: 1000,
        effect: 'slide',
        roundLengths: true,
        navigation: {
          nextEl: swiperContainer.querySelector('.slide-button-next'),
          prevEl: swiperContainer.querySelector('.slide-button-prev'),
        },
        pagination: {
          el: ".slide-thumb-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            // 配列から画像URLを取得してページネーションのポイントに設定
            return '<span class="' + className + '">' + '<img src="' + imageUrls[index] + '" alt="">' + '</span>';
          },
        },
        keyboard: {
          enabled: false, // 初期状態ではキーボード操作を無効に
          onlyInViewport: true
        }

      });
      // マウスがスライダーの上にある時にキーボード操作を有効にする
      swiperContainer.addEventListener('mouseenter', () => {
        swiper.keyboard.enable();
      });

      // マウスがスライダーから離れた時にキーボード操作を無効にする
      swiperContainer.addEventListener('mouseleave', () => {
        swiper.keyboard.disable();
      });

    });

  });
}
